import apiClient from "../utils/apiClient";
import {
  LOAD_ALL_IMAGE_NOTIFICATIONS_REQUEST,
  LOAD_ALL_IMAGE_NOTIFICATIONS_SUCCESS,
  LOAD_ALL_IMAGE_NOTIFICATIONS_FAIL,
  IMAGE_NOTIFICATION_DETAIL_REQUEST,
  IMAGE_NOTIFICATION_DETAIL_SUCCESS,
  IMAGE_NOTIFICATION_DETAIL_FAIL,
  ADD_IMAGE_NOTIFICATION_REQUEST,
  ADD_IMAGE_NOTIFICATION_SUCCESS,
  ADD_IMAGE_NOTIFICATION_FAIL,
  UPDATE_IMAGE_NOTIFICATION_REQUEST,
  UPDATE_IMAGE_NOTIFICATION_SUCCESS,
  UPDATE_IMAGE_NOTIFICATION_FAIL,
  DELETE_IMAGE_NOTIFICATION_REQUEST,
  DELETE_IMAGE_NOTIFICATION_SUCCESS,
  DELETE_IMAGE_NOTIFICATION_FAIL,
  CLEAR_ERRORS,
} from "../constants/adminImageNotificationConstants";

// Get all image notifications
export const getImageNotifications = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_ALL_IMAGE_NOTIFICATIONS_REQUEST });

    const { data } = await apiClient.get("/admin/image-notifications");

    dispatch({
      type: LOAD_ALL_IMAGE_NOTIFICATIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOAD_ALL_IMAGE_NOTIFICATIONS_FAIL,
      payload: error,
    });
  }
};

// Get single image notification
export const getImageNotificationDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: IMAGE_NOTIFICATION_DETAIL_REQUEST });

    const { data } = await apiClient.get(`/admin/image-notifications/${id}`);

    dispatch({
      type: IMAGE_NOTIFICATION_DETAIL_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: IMAGE_NOTIFICATION_DETAIL_FAIL,
      payload: error.response?.data?.errMessage || "Failed to fetch notification",
    });
  }
};

// Add image notification
export const addImageNotification =
  (title, image, imageName, link, message, backgroundColor, messageSpeed, displayLocation, active, expiresAt, countdownColor) =>
  async (dispatch) => {
    try {
      dispatch({ type: ADD_IMAGE_NOTIFICATION_REQUEST });

      const config = {
        headers: { "content-type": "application/json" },
      };

      const { data } = await apiClient.post(
        "/admin/image-notifications/add",
        { title, image, imageName, link, message, backgroundColor, messageSpeed, displayLocation, active, expiresAt: expiresAt || null, countdownColor: countdownColor || "#15803d" },
        config
      );

      dispatch({
        type: ADD_IMAGE_NOTIFICATION_SUCCESS,
        payload: data.notification,
      });
    } catch (error) {
      dispatch({
        type: ADD_IMAGE_NOTIFICATION_FAIL,
        payload: error.response?.data?.errMessage || "Failed to add notification",
        errors: error.response?.data,
      });
    }
  };

// Update image notification
export const updateImageNotification =
  (id, title, oldImage, image, imageName, link, message, backgroundColor, messageSpeed, displayLocation, active, expiresAt, countdownColor) =>
  async (dispatch) => {
    try {
      dispatch({ type: UPDATE_IMAGE_NOTIFICATION_REQUEST });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await apiClient.put(
        `/admin/image-notifications/update/${id}`,
        { title, oldImage, image, imageName, link, message, backgroundColor, messageSpeed, displayLocation, active, expiresAt: expiresAt || null, countdownColor: countdownColor || "#15803d" },
        config
      );

      dispatch({
        type: UPDATE_IMAGE_NOTIFICATION_SUCCESS,
        payload: data.success,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_IMAGE_NOTIFICATION_FAIL,
        payload: error.response?.data?.errMessage || "Failed to update notification",
        errors: error.response?.data,
      });
    }
  };

// Delete image notification
export const deleteImageNotificationData = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_IMAGE_NOTIFICATION_REQUEST });

    await apiClient.delete(`/admin/image-notifications/${id}`);

    dispatch({
      type: DELETE_IMAGE_NOTIFICATION_SUCCESS,
      payload: id,
    });
  } catch (error) {
    dispatch({
      type: DELETE_IMAGE_NOTIFICATION_FAIL,
      payload: error,
    });
  }
};

// Clear errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
